import CreateEditSchedule from './CreateEditSchedule';

export default CreateEditSchedule;
